import React, {useContext} from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import {AuthContext} from "../../config/AuthContext";
import Login from "../root/Login";
import NavBar from "../components/NavBar";
import SeccioMenuCards from "../components/SeccioMenuCards";

export default function Multilleure() {
    const {isLoggedIn} = useContext(AuthContext);

    if (!isLoggedIn) return <Login/>;

    return (
        <>
            <NavBar/>
            <div className="general">
                <SeccioMenuCards
                    pantalla="artsiesports"
                    titol="ARTiESPORT"
                    subtitol="Selecciona una secció per començar"
                />
            </div>
        </>
    );
}
